<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('routes.purchasesOrder') }}
                </v-card-title>
            </div>
        </div>
        <v-card elevation="0">
            <PurchaseOrderList />
        </v-card>
    </div>
</template>
<script>
import PurchaseOrderList from "../PurchaseOrder/PurchaseOrderList.vue";
export default {
    components: {
        PurchaseOrderList,
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.purchasesOrder');
    },
    methods: {

    }
};
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}
</style>